import { Type } from '@angular/core';
import { Logger } from '@services/logger/abstract.logger';
import { DevLogger } from '@services/logger/dev.logger';
import { ProductionLogger } from '@services/logger/production.logger';

export interface ILoggerOptions {
    production: boolean;
}

export function LoggerFactory(opt: ILoggerOptions): Type<Logger> {
    // this resolver accepts an options object
    // in the future we could have a different logger for community
    // that could capture the errors and send them server-side
    return opt.production ? ProductionLogger : DevLogger;
}
